import React from 'react';

import {
  SearchComponent,
  ISearchComponent,
} from '../../core/components/SearchComponent';

import lineModules from '../../core/components/lineModules'
import { Container } from './styles';
import { useParams } from 'react-router-dom';
import { urlWebsite } from '../../../../config';
import CopyToClipboard from '../../core/components/CopyToClipboard';

interface ValidationRules {
  type: 'email' | 'required' | 'min' | 'max' | 'length';
  message?: string;
  quantity?: number;
}

interface ValidationSchema {
  name: string;
  type: 'string' | 'number' | 'boolean';
  label: string;
  rules: Array<ValidationRules>;
}

interface ILine {
  [key: string]: string;
}
interface IParams {
  projectHash: string;
  eventHash: string;
}

interface IParams {
  projectHash: string;
  eventHash: string;
}

const CourseProducts: React.FC = () => {
  const endpoint = '/course-products-subscriptions';
  const title = 'Atividades selecionáveis';
  const { projectHash, eventHash } = useParams<IParams>();

  const schema: Record<string, any> = {
    _id: { ref: '_id', column: '_id', label: 'ID' },
    project_id: { ref: 'project_id', column: 'project_id', label: 'Projeto' },
    client_id: {
      ref: 'client_id',
      column: 'client_id_response',
      includeColumn: 'name',
      label: 'Cliente',
    },
    course_product_id: {
      ref: 'course_product_id',
      column: 'course_product_id_response',
      includeColumn: 'title',
      label: 'Atividade',
    },
    confirmed: { ref: 'confirmed', column: 'confirmed', label: 'Credenciado' },
    name: { ref: 'name', column: 'name', label: 'Nome' },
    companion_name: { ref: 'companion_name', column: 'companion_name', label: 'Convidado por' },
    createdAt: {
      ref: 'created_at',
      column: 'createdAt',
      label: 'Data de Criação',
      mask: 'date',
    },

  };
  const formSchema = {
    client_id: {
      alias: 'client_id',
      model: 'selectApi',
      name: 'client_id',
      label: 'Cliente',
      endpoint,
    },
    course_product_id: {
      alias: 'course_product_id',
      model: 'selectApi',
      name: 'course_product_id',
      label: 'Atividade',
      endpoint,
    },
    name: {
      model: 'input',
      name: 'name',
      label: 'Nome',
      defaultValue: '',
    },
    email: {
      model: 'input',
      name: 'email',
      label: 'E-mail',
      defaultValue: '',
    },
    document_number: {
      model: 'input',
      name: 'document_number',
      label: 'CPF',
      defaultValue: '',
    },
    company: {
      model: 'input',
      name: 'company',
      label: 'Empresa',
      defaultValue: '',
    },
    position: {
      model: 'input',
      name: 'position',
      label: 'Cargo',
      defaultValue: '',
    },
    confirmed: {
      model: 'selectSimple',
      name: 'confirmed',
      label: 'Credenciado',
      defaultValue: 'yes',
      options: [
        { label: 'Sim', value: 'yes' },
        { label: 'Não', value: 'no' },
      ]
    },
  };

  const formSchemaUpdate = {

    ...formSchema
  };



  const formValidation: Record<string, ValidationSchema> = {

  };



  const config: ISearchComponent = {
    idKey: `${endpoint}-${projectHash}-${eventHash}`,
    title,
    endpoint,
    schema,
    autoStart: true,
    headModules: [
      () =>
        lineModules.create({
          title,
          formSchema,
          validationSchema: formValidation,
          endpoint,
        }),
    ],
    bodyModules: [

      (lineData: Record<string, any>) =>
        lineModules.updateUnique({
          lineData,
          title,
          formSchema: formSchemaUpdate,
          validationSchema: {},
          endpoint,
        }),
      (lineData: Record<string, any>) =>
        lineModules.delete({
          lineData,
          title,
          formSchema,
          validationSchema: formValidation,
          endpoint,
        }),
    ],
  };

  return (
    <Container>
      <SearchComponent {...config} />
    </Container>
  );
};

export default CourseProducts;
